/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import cnchar from 'cnchar'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserId } from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import { Department } from '../../models/department'
import {
  getTreatmentPartsName,
  SetmealCategoris,
  SetmealCategory,
  SetmealCategoryName,
  TreatmentPartsCategoris,
} from '../../models/setmeal'
import { User } from '../../models/user'
import { getStorage } from '../durgsystem/durgsystemSlice'
import { DepartmentDate, selectDepartData } from '../putstorage/putstorageSlice'
import {
  getAllUserName,
  getUserName,
  sleectUserData,
} from '../putstorelist/putstorelistSlice'
import styles from './Setmeal.module.css'
import {
  selectSetmealSelectId,
  selectSetmealDetail,
  submitsetmealAsync,
  getLableListAsync,
} from './setmealSlice'
import { pinyin } from 'pinyin-pro'
import { SettingTreatmentParts } from '../examinetreat/settingTreatmentParts'
import { defaultXianBingListAsync } from '../treatment/tcmCases/tcmCasesSlice'
import { SettingOutlined } from '@ant-design/icons'
import { SettingLables } from './SettingLableModal'
import { UseMethodModal } from '../treatment/editor/UseMethodModal'
import { DefaultUseMethod } from '../../models/recipeusemethod'
const { Option } = Select
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
}

export const SetmealModal = (props: {
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
  recipeId?: any
}) => {
  const [setmealTitle, setSetmealTitle] = useState('新增')

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const inputRef = useRef<Input>(null)

  const [editTreatmentParts, setEditTreatmentParts] = useState(false)

  const [editLablesVisible, setEditLablesVisible] = useState(false)

  const [categoryValue, setCategoryValue] = useState<any>()

  const [treatmentParts, setTreatmentParts] = useState<string>('')

  const [treatmentPartsList, setTreatmentPartsList] = useState<any>([])

  const [param, setParam] = useState<any>({})

  const [isUseMethodModalVisible, setIsUseMethodModalVisible] = useState(false)

  const [recipeUseMethodHTData, setRecipeUseMethodHTData] = useState<string[]>(
    DefaultUseMethod
  )

  const [elseRecipeUseMethod, setElseRecipeUseMethod] = useState<any>({})

  const SelectId = useSelector(selectSetmealSelectId)

  const [selectuseArea, setSelectuseArea] = useState(2)

  const [lableList, setLableList] = useState<any>()

  const setmealDetail: any = useSelector(selectSetmealDetail)

  const userId = useSelector(selectUserId)

  useEffect(() => {
    if (JSON.stringify(setmealDetail) !== '{}') {
      setSetmealTitle('修改')
      setSelectuseArea(setmealDetail.useArea)
      dispatch(DepartmentDate({ current: 1, size: 1000, status: 1 }))
      dispatch(getUserName(setmealDetail.useDepartmentId))
      setCategoryValue(setmealDetail.category)
      setRecipeUseMethodHTData(setmealDetail?.comboUseMethod ? setmealDetail?.comboUseMethod?.split(',') : DefaultUseMethod)
      setIsUseMethodModalVisible(false)
      const fValue: any = setmealDetail?.comboNormalFrequency
        ? ',' +
        (setmealDetail?.comboNormalFrequency
          ? setmealDetail?.comboNormalFrequency + ','
          : '') +
        (setmealDetail?.comboNormalUsemethod
          ? setmealDetail?.comboNormalUsemethod + ','
          : '') +
        (setmealDetail?.comboNormalDose
          ? setmealDetail?.comboNormalDose + ','
          : '')
        : ''
      const packageUsage = setmealDetail?.comboUseMethod + fValue + (setmealDetail?.remark ? (setmealDetail?.remark) : '')

      form.setFieldsValue({
        name: setmealDetail.name,
        mnemonicCode: setmealDetail.mnemonicCode,
        category: setmealDetail.category,
        useArea: setmealDetail.useArea,
        useDepartmentId: setmealDetail.useDepartmentId,
        useDepartmentName: setmealDetail.useDepartmentName,
        useUserId: setmealDetail.useUserId?.toString(),
        packageUsage: packageUsage,
        useUserName: setmealDetail.useUserName,
        flag: setmealDetail.flag,
        sort: setmealDetail.sort > 0 ? setmealDetail.sort : '',
        treatmentParts: setmealDetail?.treatmentParts
          ? setmealDetail?.treatmentParts?.split(',')
          : [],
        labelIds: setmealDetail?.labelIds
          ? setmealDetail?.labelIds?.split(',')
          : [],
      })


      setElseRecipeUseMethod({
        recipeNormalFrequency: setmealDetail?.comboNormalFrequency,
        recipeNormalUsemethod: setmealDetail?.comboNormalUsemethod,
        recipeNormalDose: setmealDetail?.comboNormalDose,
        remark: setmealDetail?.remark,
      })
      console.log(setmealDetail, "setmealDetail")

    } else {
      setSetmealTitle('新增')
      form.setFieldsValue({
        flag: 0,
      })
      setCategoryValue('')
      setRecipeUseMethodHTData(DefaultUseMethod)
      setElseRecipeUseMethod({})
    }
  }, [setmealDetail])

  useEffect(() => {
    dispatch(getStorage({ current: 1 }))
    dispatch(getAllUserName({ current: 1, size: 1000 }))
  }, [])

  const departmentData = useSelector(selectDepartData)

  const userData = useSelector(sleectUserData)

  useEffect(() => {
    if (props?.isModalVisible) {
      dispatch(defaultXianBingListAsync(2))
        .then(unwrapResult)
        .then((res: any) => {
          setTreatmentPartsList(res)
        })
      getLableList()
    }
  }, [props?.isModalVisible])

  const getLableList = () => {
    dispatch(getLableListAsync())
      .then(unwrapResult)
      .then((v: any) => {
        setLableList(v)
      })
  }

  useEffect(() => {
    if (props.isModalVisible && !SelectId) {
      // 添加一个小延迟，确保DOM元素已经完全渲染后再调用focus
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [props.isModalVisible, SelectId])

  return (
    <Modal
      title={props?.recipeId ? '设置为套餐' : setmealTitle + '套餐'}
      visible={props.isModalVisible}
      className={styles.setmealform}
      onOk={() => {
        props.onOk()
      }}
      onCancel={() => {
        form.resetFields()
        props.onCancel()
        setSelectuseArea(2)
      }}
      footer={null}
    >
      <Form
        autoComplete='off'
        {...layout}
        form={form}
        name='control-hooks'
        onFinish={(vs) => {
          const useDepartmentName =
            (departmentData.find(
              (d: any) => d.id === vs.useDepartmentId
            ) as any)?.name || ''
          const useUserName =
            (userData.find((u: any) => u.id === vs.useUserId) as any)?.name ||
            ''
          if (SelectId) {
            dispatch(
              submitsetmealAsync({
                ...param,
                ...vs,
                packageUsage: undefined,
                useDepartmentName,
                useUserName,
                id: SelectId,
                recipeId: props?.recipeId ? props?.recipeId : null,
                treatmentParts: vs?.treatmentParts?.length
                  ? vs?.treatmentParts?.join(',')
                  : '',
                labelIds: vs?.labelIds?.length ? vs?.labelIds?.join(',') : '',
              })
            )
              .then(unwrapResult)
              .then(() => {
                form.resetFields()
                props.onOk()
                setSelectuseArea(2)
                if (props?.recipeId) {
                  notification.success({
                    message: '设置成功',
                  })
                }
              })
          } else {
            dispatch(
              submitsetmealAsync({
                ...param,
                ...vs,
                packageUsage: undefined,
                useDepartmentName,
                useUserName,
                recipeId: props?.recipeId ? props?.recipeId : null,
                treatmentParts: vs?.treatmentParts?.length
                  ? vs?.treatmentParts?.join(',')
                  : '',
                labelIds: vs?.labelIds?.length ? vs?.labelIds?.join(',') : '',
              })
            )
              .then(unwrapResult)
              .then(() => {
                form.resetFields()
                props.onOk()
                setSelectuseArea(2)
                if (props?.recipeId) {
                  notification.success({
                    message: '设置成功',
                  })
                }
              })
          }
        }}
      >
        <Form.Item
          name='name'
          label='套餐名称'
          rules={[
            {
              required: true,
            },
            {
              max: 40,
              message: '最长40位!',
            },
          ]}
        >
          <Input
            ref={inputRef}
            onInput={(e: any) => {
              form.setFieldsValue({
                mnemonicCode: pinyin(e.target.value, {
                  pattern: 'first',
                  toneType: 'none',
                  separator: '',
                }).toUpperCase(),
              })
            }}
          />
        </Form.Item>

        <Form.Item
          name='mnemonicCode'
          label='助记码'
          rules={[
            {
              required: true,
            },
            {
              max: 40,
              message: '最长40位!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name='category'
          label='套餐类别'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            disabled={Boolean(
              SelectId && JSON.stringify(setmealDetail) !== '{}'
            )}
            onChange={(value: SetmealCategory) => {
              setCategoryValue(value)
            }}
          >
            {SetmealCategoris.map((v) => {
              return (
                <Option value={v} key={v}>
                  {SetmealCategoryName(v)}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
        <Col span={24} style={{ position: 'relative' }}>
          <Form.Item name='treatmentParts' label='部位'>
            <Select
              mode='multiple'
              allowClear
              value={treatmentParts}
              onChange={(value: any) => {
                setTreatmentParts(value)
              }}
            >
              {TreatmentPartsCategoris?.map((v) => {
                return (
                  <Option key={v} value={getTreatmentPartsName(v)}>
                    {getTreatmentPartsName(v)}
                  </Option>
                )
              })}
              {treatmentPartsList.map((v: any) => {
                return (
                  <Option key={v.id} value={v.name}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <div style={{ position: 'absolute', top: '6px', right: '7px' }}>
            <SettingOutlined
              style={{ color: '#999999' }}
              onClick={() => setEditTreatmentParts(true)}
            />
          </div>
        </Col>
        {categoryValue == SetmealCategory.ZYTC ? (
          <Form.Item
            name='packageUsage'
            label='套餐用法'
          >
            <Input
              size='middle'
              allowClear
              onClick={(() => {
                console.log('点击了套餐用法')
                setIsUseMethodModalVisible(true)
              })} />
          </Form.Item>
        ) : (
          <></>
        )}
        <Form.Item
          name='useArea'
          label='使用范围'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            allowClear
            onSelect={(values: number) => {
              if (values === 1) {
                dispatch(DepartmentDate({ current: 1, size: 1000, status: 1 }))
                form.setFieldsValue({
                  useDepartmentId:
                    setmealDetail.useDepartmentId > 0
                      ? setmealDetail.useDepartmentId
                      : undefined,
                })
              }
              if (values === 0) {
                dispatch(getAllUserName({ current: 1, size: 1000 }))
                form.setFieldsValue({
                  useUserId: userId,
                })
              }
              setSelectuseArea(values as number)
            }}
          >
            <Option value={0}>个人</Option>
            <Option value={1}>部门</Option>
            <Option value={2}>全院</Option>
          </Select>
        </Form.Item>
        {selectuseArea === 1 ? (
          <Form.Item
            name='useDepartmentId'
            label='使用科室'
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              allowClear
              onSelect={(key: any) => {
                form.setFieldsValue({
                  useUserId: undefined,
                })
              }}
            >
              {departmentData.map((v: Department) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
        ) : (
          <></>
        )}

        {selectuseArea === 0 ? (
          <Form.Item
            name='useUserId'
            label='使用人员'
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select allowClear disabled>
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
        ) : (
          <></>
        )}

        <Form.Item name='flag' label='允许他人修改'>
          <Select defaultValue={0}>
            <Option value={0}>否</Option>
            <Option value={1}>是</Option>
          </Select>
        </Form.Item>
        <Col span={24} style={{ position: 'relative' }}>
          <Form.Item name='labelIds' label='标签'>
            <Select mode='multiple'>
              {lableList?.map((v: any) => {
                return (
                  <Option key={v.id?.toString()} value={v.id?.toString()}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <div style={{ position: 'absolute', top: '6px', right: '6px' }}>
            <SettingOutlined
              style={{ color: '#999999' }}
              onClick={() => setEditLablesVisible(true)}
            />
          </div>
        </Col>
        <Form.Item name='sort' label='排序'>
          <InputNumber max={99999} min={1} style={{ width: '404px' }} />
        </Form.Item>
        <Row gutter={20}>
          <Col span={12}>
            <Button
              onClick={() => {
                form.resetFields()
                setSelectuseArea(2)
                props.onCancel()
              }}
              style={{ float: 'right' }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button type='primary' htmlType='submit' style={{ float: 'left' }}>
              保存
            </Button>
          </Col>
        </Row>
      </Form>
      <SettingTreatmentParts
        isSettingTreatmentParts={editTreatmentParts}
        onCancel={() => {
          setEditTreatmentParts(false)
        }}
        onOk={() => {
          setEditTreatmentParts(false)
        }}
        refresh={() => {
          dispatch(defaultXianBingListAsync(2))
            .then(unwrapResult)
            .then((res) => {
              setTreatmentPartsList(res)
            })
        }}
      />
      <SettingLables
        visible={editLablesVisible}
        onCancel={() => {
          setEditLablesVisible(false)
        }}
        onOk={() => {
          setEditLablesVisible(false)
        }}
        refresh={() => {
          getLableList()
        }}
      />
      <UseMethodModal
        visible={isUseMethodModalVisible}
        value={recipeUseMethodHTData}
        elseRecipeUseMethod={elseRecipeUseMethod}
        onCancel={() => {
          setIsUseMethodModalVisible(false)
        }}
        onChange={(values, formValue) => {
          const filterValues = values?.filter((v) => v != '')
          setIsUseMethodModalVisible(false)
          const fValue: any = formValue
            ? ',' +
            (formValue?.recipeNormalFrequency
              ? formValue?.recipeNormalFrequency + ','
              : '') +
            (formValue?.recipeNormalUsemethod
              ? formValue?.recipeNormalUsemethod + ','
              : '') +
            (formValue?.recipeNormalDose
              ? formValue?.recipeNormalDose + ','
              : '')
            : ''
          const useMethod = filterValues.join(',') + fValue + (formValue?.remark ? (formValue?.remark) : '')
          console.log(values, "formValue")
          form.setFieldsValue({
            packageUsage: useMethod,
          })
          setParam({
            comboUseMethod: filterValues.join(','),
            comboNormalFrequency: formValue?.recipeNormalFrequency,
            comboNormalUsemethod: formValue?.recipeNormalUsemethod,
            comboNormalDose: formValue?.recipeNormalDose,
            remark: formValue?.remark,
          })
          setRecipeUseMethodHTData(values) //回填数据
          // dispatch(
          //   createOrUpdateRecipe({
          //     ...recipe,
          //     ...formValue,
          //     tip: tipCount,
          //     useMethod: filterValues.join(','),
          //   } as Recipe)
          // )
          //   .then(unwrapResult)
          //   .then((res) => {
          //     setElseMethod(fValue)
          //   })
        }}
      />
    </Modal>
  )
}
